<ol class="breadcrumb container" [ngStyle]="{ display: rotaAtual ? 'none' : 'flex' }">
  <li *ngFor="let breadcrumb of breadcrumb$ | async; last as isLast" class="breadcrumb-item"
    [ngClass]="{ active: isLast }" aria-current="page">
    <a *ngIf="!isLast; else lastRoute" [routerLink]="[breadcrumb.url]" [queryParams]="{ id: breadcrumb.id }"
      class="link breadcrumb-link" [ngClass]="{
        home: breadcrumb.label === 'Principal',
        anterior: breadcrumb.label !== 'Principal'
      }">
      {{ breadcrumb.label }}
    </a>
    <ng-template #lastRoute>
      <a class="anterior breadcrumb-link" *ngIf="breadcrumb.label !== 'Principal'">{{
        breadcrumb.label
        }}</a>
    </ng-template>
  </li>
</ol>